'use strict';

module.exports = require('./src/js/main');



//////////////////
// WEBPACK FOOTER
// ./~/perfect-scrollbar/index.js
// module id = 42
// module chunks = 6